<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-row justify="space-between" align="center">
            <v-col cols="12" md="6">
              <h3>{{ convocatoriaData?.convocatoria || 'Convocatoria' }}</h3>
              <p class="mb-0">Personal vinculado: {{ personalItems.length }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <v-row align="center" justify="end" class="mx-0">
                <v-col>
                  <v-text-field
                    v-model="buscaPersonal"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="primary"
                    color="secondary"
                    label="Buscar personal"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto" class="pr-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton variant="secondary" icon="mdi-download" @click="downloadPersonalCsv" />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                class="primary"
                :headers="headers"
                :items="filteredPersonal"
                :loading="loading"
                loading-text="Cargando personal..."
                dense
                calculate-widths
              >
                <template v-slot:[`item.nombreCompleto`]="{ item }">
                  {{ item.nombreCompleto || '-' }}
                </template>

                <template v-slot:[`item.aceptado`]="{ item }">
                  <v-switch
                    :input-value="item.aceptado"
                    color="secondary"
                    dense
                    hide-details
                    :disabled="updating"
                    @change="mostrarConfirmacionAceptado(item, $event)"
                  ></v-switch>
                </template>

                <template v-slot:[`item.promocionado`]="{ item }">
                  <v-switch
                    :input-value="item.promocionado"
                    color="secondary"
                    dense
                    hide-details
                    :disabled="updating"
                    @change="mostrarConfirmacionPromocionado(item, $event)"
                  ></v-switch>
                </template>

                <template v-slot:[`item.acciones`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton
                          class="mr-2"
                          variant="secondary"
                          elevation="8"
                          icon="mdi-delete-alert-outline"
                          @click="confirmarEliminarPersonal(item)"
                        />
                      </span>
                    </template>
                    <span>Desvincular personal de convocatoria</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmDialog" persistent width="600">
      <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
        <v-card-title class="d-flex font-weight-bold justify-space-between ui-module-titlebar">
          <div>Confirmación</div>
          <v-btn icon @click="cancelarConfirmacion">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <h3 class="mb-4 text-center">{{ mensajeConfirmacion }}</h3>
          <div class="d-flex justify-center">
            <TextButton color="error" class="mr-2" :disabled="confirmLoading" @click="cancelarConfirmacion">
              Cancelar
            </TextButton>
            <TextButton
              color="secondary"
              :loading="confirmLoading"
              :disabled="confirmLoading"
              @click="confirmarActualizacion"
            >
              Confirmar
            </TextButton>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import IconButton from '@/components/base/IconButton.vue'
import TextButton from '@/components/base/TextButton.vue'
import downloadCsv from '@/utils/downloadCsv'

export default {
  name: 'PersonalVinculadoConvocatoriaDialogComponent',
  components: {
    IconButton,
    TextButton,
  },

  props: {
    convocatoriaData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      buscaPersonal: '',
      loading: false,
      updating: false,
      personalItems: [],
      confirmDialog: false,
      confirmLoading: false,
      confirmItem: null,
      confirmTipoActualizacion: '',
      confirmNuevoValor: false,
      headers: [
        { text: 'CUIP', value: 'CUIP', align: 'left' },
        { text: 'Personal', value: 'nombreCompleto', align: 'left' },
        { text: 'Puesto', value: 'puesto', align: 'left' },
        { text: 'Dependencia', value: 'dependencia', align: 'left' },
        { text: 'Aceptado', value: 'aceptado', align: 'center', sortable: false },
        { text: 'Promocionado', value: 'promocionado', align: 'center', sortable: false },
        { text: 'Opciones', value: 'acciones', align: 'center', sortable: false },
      ],
    }
  },

  computed: {
    filteredPersonal() {
      const term = (this.buscaPersonal || '').trim().toLowerCase()
      const items = this.personalItems || []
      if (!term) return items
      return items.filter((p) => {
        const nombre = (p.nombreCompleto || '').toLowerCase()
        const cuip = (p.CUIP || '').toLowerCase()
        const puesto = (p.puesto || '').toLowerCase()
        const dependencia = (p.dependencia || '').toLowerCase()
        return nombre.includes(term) || cuip.includes(term) || puesto.includes(term) || dependencia.includes(term)
      })
    },
    mensajeConfirmacion() {
      if (!this.confirmItem) return ''

      if (this.confirmTipoActualizacion === 'aceptado') {
        const accion = this.confirmNuevoValor ? 'Aceptada' : 'NO Aceptada'
        return `¿Está seguro de que desea marcar como ${accion} esta convocatoria para ${this.confirmItem.nombreCompleto}?`
      }

      const accion = this.confirmNuevoValor ? 'Promocionado' : 'NO Promocionado'
      return `¿Está seguro de que desea marcar como ${accion} para esta convocatoria a ${this.confirmItem.nombreCompleto}?`
    },
  },

  async mounted() {
    await this.loadPersonalVinculado()
  },

  methods: {
    ...mapActions('convocatorias', [
      'fetchPersonalByConvocatoria',
      'deletePersonalConvocatoria',
      'updatePersonalConvocatoria',
    ]),
    ...mapMutations('dialog', ['SET_DIALOG']),

    async loadPersonalVinculado() {
      const idConvocatoria = this.convocatoriaData?.id

      if (!idConvocatoria) {
        console.error('No se proporcionó id de convocatoria')
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: No se proporcionó el ID de la convocatoria')
        return
      }

      try {
        this.loading = true
        const result = await this.fetchPersonalByConvocatoria(idConvocatoria)
        this.personalItems = Array.isArray(result) ? result : []
      } catch (error) {
        console.error('Error al cargar el personal vinculado:', error)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar el personal vinculado')
      } finally {
        this.loading = false
      }
    },

    mostrarConfirmacionAceptado(item, newValue) {
      this.openConfirmacion(item, 'aceptado', newValue)
    },

    mostrarConfirmacionPromocionado(item, newValue) {
      this.openConfirmacion(item, 'promocionado', newValue)
    },

    confirmarEliminarPersonal(item) {
      this.updating = true
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_ELIMINAR_PERSONAL_CONVOCATORIA,
        props: {
          personalData: item,
        },
        listeners: {
          confirmed: () => {
            this.eliminarPersonalConvocatoria(item)
          },
          cancelled: () => {
            this.updating = false
          },
        },
      })
    },

    async eliminarPersonalConvocatoria(item) {
      try {
        await this.deletePersonalConvocatoria({
          idPersonal: item.id_personal,
          idConvocatoriaPersonal: item.idConvocatoriaPersonal,
        })
        this.personalItems = (this.personalItems || []).filter(
          (p) => p.id_personal !== item.id_personal && p.idConvocatoriaPersonal !== item.idConvocatoriaPersonal
        )
      } catch (error) {
        console.error('Error al eliminar la asignación:', error)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al eliminar la asignación de personal')
      } finally {
        this.updating = false
      }
    },

    applyLocalUpdate(payload) {
      const { idConvocatoriaPersonal, idPersonal, aceptado, promocionado } = payload || {}
      const index = (this.personalItems || []).findIndex(
        (item) => item.idConvocatoriaPersonal === idConvocatoriaPersonal || item.id_personal === idPersonal
      )

      if (index === -1) return

      const current = this.personalItems[index]
      const updated = {
        ...current,
        aceptado: typeof aceptado === 'boolean' ? aceptado : current.aceptado,
        promocionado: typeof promocionado === 'boolean' ? promocionado : current.promocionado,
      }

      this.personalItems.splice(index, 1, updated)
    },

    openConfirmacion(item, tipoActualizacion, nuevoValor) {
      this.confirmItem = item
      this.confirmTipoActualizacion = tipoActualizacion
      this.confirmNuevoValor = !!nuevoValor
      this.confirmDialog = true
      this.updating = true
    },

    cancelarConfirmacion() {
      this.confirmDialog = false
      this.confirmLoading = false
      this.confirmItem = null
      this.confirmTipoActualizacion = ''
      this.confirmNuevoValor = false
      this.updating = false
    },

    async confirmarActualizacion() {
      if (!this.confirmItem?.id_personal) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: Falta ID del personal')
        this.cancelarConfirmacion()
        return
      }

      if (!this.confirmItem?.idConvocatoriaPersonal) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: Falta ID de la convocatoria del personal')
        this.cancelarConfirmacion()
        return
      }

      this.confirmLoading = true

      try {
        const payload = {
          idConvocatoriaPersonal: this.confirmItem.idConvocatoriaPersonal,
          aceptado:
            this.confirmTipoActualizacion === 'aceptado' ? this.confirmNuevoValor : this.confirmItem.aceptado ?? false,
          promocionado:
            this.confirmTipoActualizacion === 'promocionado'
              ? this.confirmNuevoValor
              : this.confirmItem.promocionado ?? false,
        }

        await this.updatePersonalConvocatoria({
          idPersonal: this.confirmItem.id_personal,
          idConvocatoriaPersonal: this.confirmItem.idConvocatoriaPersonal,
          payload,
        })

        const mensaje =
          this.confirmTipoActualizacion === 'aceptado'
            ? 'Estado de aceptación actualizado correctamente'
            : 'Estado de promoción actualizado correctamente'

        this.$store.commit('SET_SNACKBAR_MESSAGE', mensaje)
        this.applyLocalUpdate({
          idPersonal: this.confirmItem.id_personal,
          idConvocatoriaPersonal: this.confirmItem.idConvocatoriaPersonal,
          aceptado: payload.aceptado,
          promocionado: payload.promocionado,
        })

        this.cancelarConfirmacion()
      } catch (error) {
        console.error('Error al actualizar:', error)
        const mensaje =
          this.confirmTipoActualizacion === 'aceptado'
            ? 'Error al actualizar el estado de aceptación'
            : 'Error al actualizar el estado de promoción'

        this.$store.commit('SET_SNACKBAR_MESSAGE', mensaje)
        this.cancelarConfirmacion()
      } finally {
        this.confirmLoading = false
      }
    },

    downloadPersonalCsv() {
      const convName = this.convocatoriaData?.convocatoria || 'Convocatoria'
      const rows = (this.filteredPersonal || []).map((item) => ({
        Convocatoria: convName,
        CUIP: item.CUIP || '',
        Personal: item.nombreCompleto || '',
        Puesto: item.puesto || '',
        Dependencia: item.dependencia || '',
        Aceptado: item.aceptado ? 'Sí' : 'No',
        Promocionado: item.promocionado ? 'Sí' : 'No',
      }))

      const filename = `personal-vinculado-${convName}`
      downloadCsv(rows, { filename })
    },
  },
}
</script>
